import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';

import { CardDestinationFundType } from '../types/MovimentacaoFundosType';

export const CardDestination = ({
  isOriginFundSelected,
  destinationFundSelectedList,
  handleIncrementPercentage,
  handleDecrementPercentage,
  handleInputChangeDestinationFund,
  parentRef
}: CardDestinationFundType) => {
  return (
    <div
      className={`tw-w-full tw-max-w-[554px] tw-mt-10 tw-rounded-lg ${
        !isOriginFundSelected ? 'tw-cursor-not-allowed' : ''
      }`}
    >
      <div className="tw-p-4 tw-bg-[#001E64] tw-text-white tw-font-bold tw-rounded-t-lg tw-border-2 tw-border-[#001E64] tw-text-center">
        Destino
      </div>
      <div
        ref={parentRef}
        className={`tw-border-b-2 tw-border-l-2 tw-border-r-2 tw-border-gray-300 tw-rounded-b-lg ${
          !isOriginFundSelected ? 'tw-pointer-events-none' : ''
        } `}
      >
        <div className="tw-p-4 tw-flex tw-items-center tw-justify-between">
          <span>Fundo</span>
          <span>% de transferência</span>
        </div>
        <div className="tw-h-auto tw-max-h-[300px] tw-overflow-y-auto tw-scrollbar-customized">
          {destinationFundSelectedList.map((fundo, index) => (
            <div
              key={index}
              data-testid={`fund-destanation-list-${fundo.idFundo}`}
              className={`tw-p-4 linha-fundo-destino ${
                index % 2 === 0 ? 'tw-bg-[#F3F3F3]' : 'tw-bg-[#E9EEF6]'
              }
        ${index === length - 1 && 'tw-rounded-b-lg'} ${
                !isOriginFundSelected && 'tw-cursor-not-allowed'
              } tw-flex tw-items-center tw-justify-between`}
              id={`fundo-destino-${fundo.idFundo}`}
            >
              <span
                className={`${
                  !isOriginFundSelected ? 'tw-text-[#838181]' : ''
                } tw-max-w-[415px]`}
              >
                {fundo.descricao}
              </span>
              <div
                className={`tw-flex tw-w-[98px] tw-h-[42px] tw-bg-white tw-rounded-[6px] ${
                  isOriginFundSelected
                    ? 'tw-border-2 tw-border-[#001E64]'
                    : 'tw-border-2 tw-border-gray-400'
                }`}
              >
                <input
                  type="number"
                  className={`input-percentual-fundo tw-flex tw-items-center tw-w-full tw-h-full tw-ml-2 tw-rounded-[6px] tw-outline-none ${
                    !isOriginFundSelected && 'tw-cursor-not-allowed'
                  }`}
                  value={destinationFundSelectedList[index].valor}
                  placeholder="%"
                  disabled={!isOriginFundSelected}
                  onChange={(event) => {
                    event.target.value = String(
                      Math.abs(Number(event.target.value))
                    );
                    if (Number(event.target.value) > 100) {
                      event.target.value = '100';
                    }
                    handleInputChangeDestinationFund(
                      index,
                      Math.abs(Number(event.target.value) || 0),
                      event
                    );
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Backspace') {
                      handleInputChangeDestinationFund(index, 0, event);
                    }
                    if (event.key === '.' || event.key === ',') {
                      event.preventDefault();
                    }
                  }}
                />
                <div className="tw-flex tw-flex-col tw-justify-center tw-mr-1 tw-items-center">
                  <button
                    onClick={() =>
                      handleIncrementPercentage(index, 'destination')
                    }
                  >
                    <TriangleUpIcon color="#1B365D" w="10px" h="7px" />
                  </button>
                  <button
                    onClick={() =>
                      handleDecrementPercentage(index, 'detination')
                    }
                  >
                    <TriangleDownIcon color="#1B365D" w="10px" h="7px" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
